module.exports = __webpack_public_path__ + "static/media/findus.03ef4140.png";